__turbopack_context__.v({
  "blok-big-title": "MediaGalleryBlok-module__Z-u1KW__blok-big-title",
  "blok-subtitle": "MediaGalleryBlok-module__Z-u1KW__blok-subtitle",
  "blok-title": "MediaGalleryBlok-module__Z-u1KW__blok-title",
  "card": "MediaGalleryBlok-module__Z-u1KW__card",
  "card__wrapper": "MediaGalleryBlok-module__Z-u1KW__card__wrapper",
  "cards": "MediaGalleryBlok-module__Z-u1KW__cards",
  "root": "MediaGalleryBlok-module__Z-u1KW__root",
  "tag": "MediaGalleryBlok-module__Z-u1KW__tag",
  "title": "MediaGalleryBlok-module__Z-u1KW__title",
});
